import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import FormModal from "./FormModal";
import { useParams } from "react-router-dom";

export default function EventPage({ events }) {
  const [event, setEvent] = useState({});
  const [eventExpired, setEventExpired] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (events.length !== 0) {
      const fetchedEvent = events.filter((value) => value._id === id)[0];
      setEvent(fetchedEvent);
    }
  }, [id, events]);

  // Find the minimum price value using reduce
  const minPrice = event?.tickets?.reduce((min, ticket) => {
    return parseInt(ticket.price) < min ? parseInt(ticket.price) : min;
  }, Infinity);

  const [showFormModal, setShowFormModal] = useState(false);

  useEffect(() => {
    if (showFormModal) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [showFormModal]);

  useEffect(() => {
    const currentDate = new Date();

    // Parse the event date and time
    const eventDateParts = event?.date?.split(" ");
    const eventTimeParts = event?.time?.split(" ");

    if (eventDateParts && eventTimeParts) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const eventMonth = months.indexOf(eventDateParts[0]);
      const eventDay = parseInt(eventDateParts[1], 10);
      const eventYear = parseInt(eventDateParts[2], 10);

      const [eventHour, eventMinute] = eventTimeParts[0].split(":");
      const isAM = eventTimeParts[1] === "AM";
      const eventHour24 = isAM
        ? parseInt(eventHour, 10)
        : parseInt(eventHour, 10) + 12;
      const eventMinuteInt = parseInt(eventMinute, 10);

      const eventDate = new Date(
        eventYear,
        eventMonth,
        eventDay,
        eventHour24,
        eventMinuteInt
      );

      if (currentDate > eventDate) {
        setEventExpired(true);
      }
    }
  }, [event]);

  return (
    <div className="">
      <section className="">
        <div className="md:mx-[-32px] mx-[-16px]">
          <img
            src={
              event.banner
                ? event.banner
                : "https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/Home.webp"
            }
            className="w-full"
            alt=""
          />
        </div>
      </section>
      <section className="container flex mt-5">
        <div className="md:w-3/5 md:ml-48">
          <h1 className="text-2xl md:text-4xl font-bold mb-2">
            {event.eventName}
          </h1>
          <div className="flex space-x-7 ml-1">
            <div className="flex items-center space-x-2">
              <FontAwesomeIcon
                className="text-ambhosOrange"
                icon={faCalendar}
              />
              <p>
                {event.date} | {event.time}
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <FontAwesomeIcon
                className="text-ambhosOrange"
                icon={faLocationDot}
              />
              <p>{event.location}</p>
            </div>
          </div>
          <hr className="my-4" />
          <div className="md:hidden text-center my-4">
            <div className="w-full py-5 bg-ambhosLiteOrange">
              <p className="text-xl font-semibold">
                ₹{minPrice ? minPrice : 0} onwards
              </p>
              {!eventExpired ? (
                <button
                  className="mt-2 px-10 py-2 rounded-full bg-ambhosOrange text-white active:scale-95"
                  onClick={() => setShowFormModal(true)}
                >
                  Book Now
                </button>
              ) : (
                <p className="mt-5 py-2 font-semibold text-red-500 text-2xl">
                  Event Closed
                </p>
              )}
              {showFormModal && (
                <FormModal
                  setShowFormModal={setShowFormModal}
                  tickets={event.tickets}
                  eventName={event.eventName}
                  eventId={event._id}
                />
              )}
            </div>
          </div>
          <div>
            <h2 className="font-semibold text-gray-700 text-lg underline">
              EVENT INFORMATION
            </h2>
            {/* <p>{eventContent}</p> */}
            <p
              className="text-gray-900"
              dangerouslySetInnerHTML={{ __html: event.eventInformation }}
            ></p>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-5">
              {event?.images?.length > 0 ? (
                event?.images?.map((image) => (
                  <img className="w-40 h-40" src={image} alt="" />
                ))
              ) : (
                <>
                  <img
                    className="w-40 h-40"
                    src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/football.webp"
                    alt=""
                  />
                  <img
                    className="w-40 h-40"
                    src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/football.webp"
                    alt=""
                  />
                  <img
                    className="w-40 h-40"
                    src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/football.webp"
                    alt=""
                  />
                </>
              )}
            </div>
          </div>
          <hr className="my-4" />
          <div>
            <h2 className="font-semibold underline text-gray-700 text-lg">
              VENUE
            </h2>
            <p>{event.venue}</p>
          </div>
        </div>
        {/* Registeration form/Payment option and Event Ended Tag */}
        <div className="hidden md:block text-center w-2/5 m-4">
          <div className="mx-5 border-2 py-5 rounded-xl">
            <p className="text-2xl font-semibold">
              ₹{minPrice ? minPrice : 0} onwards
            </p>
            {!eventExpired ? (
              <button
                className="mt-5 px-10 py-2 rounded-full bg-ambhosOrange text-white active:scale-95"
                onClick={() => setShowFormModal(true)}
              >
                Book Now
              </button>
            ) : (
              <p className="mt-5 py-2 font-semibold text-red-500 text-2xl">
                Event Closed
              </p>
            )}
            {showFormModal && (
              <FormModal
                setShowFormModal={setShowFormModal}
                tickets={event.tickets}
                eventName={event.eventName}
                eventId={event._id}
              />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
